import { AnimatePresence, motion } from "framer-motion";
import { Lock } from "lucide-react";
import React, { useEffect, useState } from "react";
import { DEMO_READONLY_EVENT } from "../lib/demoGuard";
import { useT } from "../i18n/useT";

/** Shown when the user tries to persist changes in hosted demo mode. */
export function DemoReadOnlyToast() {
  const { t } = useT();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    const onBlocked = () => {
      setOpen(true);
      clearTimeout(timer);
      timer = setTimeout(() => setOpen(false), 4500);
    };
    window.addEventListener(DEMO_READONLY_EVENT, onBlocked);
    return () => {
      window.removeEventListener(DEMO_READONLY_EVENT, onBlocked);
      clearTimeout(timer);
    };
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          className="fixed bottom-24 left-1/2 -translate-x-1/2 z-[70] max-w-sm w-[calc(100%-2rem)] pointer-events-none"
          role="alert"
        >
          <div className="flex items-start gap-2.5 rounded-xl border border-amber-300/60 bg-amber-50 text-amber-950 dark:bg-amber-950/90 dark:text-amber-50 dark:border-amber-700/60 shadow-lg px-4 py-3">
            <Lock size={16} className="shrink-0 mt-0.5" aria-hidden />
            <p className="text-sm leading-snug">{t("demo.readOnly")}</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
